import React from "react";
import {Link} from "react-router-dom";

const Navbar = ({history}) => {
  return (
    <div className='navbar-container'>
      <a href='https://dignicolombia.org/' title='Fundación Colombia Unida por la Dignidad' rel='home'>
        <img src='https://dignicolombia.org/wp-content/uploads/2019/04/Grupo-802.png' alt='Fundación Colombia Unida por la Dignidad' />
      </a>

      <div className='navbar-link-container'>
        <a href='https://dignicolombia.org/memoriasdelahabladora/' title='Fundación Colombia Unida por la Dignidad' rel='home'>
          Acerca de Nosotros
        </a>
        {/*     <Link to='/records'> Records</Link> */}
        <Link to='/rules'>Reglas</Link>
        <Link to='/'>Inicio</Link>
      </div>
    </div>
  );
};

export default Navbar;